module.exports = __webpack_public_path__ + "static/img/phone_1.cc051e8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/phone_1.png
// module id = zobH
// module chunks = 0